import * as Sentry from '@sentry/react';
import { ApolloCache } from '@apollo/client';
import { useMutation } from '@apollo/client/react';
import {
  ZUGANG_AKTIVIEREN,
  ZUGANG_DEAKTIVIEREN,
} from '../lib/graphql/mutations';

const ZUGANG_AKTIVIERUNG_SUCCESS = 'ZugangAktivierungSuccess';

export type ZugangAktivierung = {
  setzeAktiv: (neuerWert: boolean) => Promise<boolean>;
  loading: boolean;
};

export function useZugangAktivierung(uidZugang: string): ZugangAktivierung {
  function schreibeAktivInCache(cache: ApolloCache, neuerWert: boolean) {
    cache.modify({
      id: cache.identify({ __typename: 'Zugang', uid: uidZugang }),
      fields: { aktiv: () => neuerWert },
    });
  }

  const [aktiviere, { loading: aktiviereLaeuft }] = useMutation(
    ZUGANG_AKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.aktiviereZugang.__typename === ZUGANG_AKTIVIERUNG_SUCCESS) {
          schreibeAktivInCache(cache, true);
        }
      },
    },
  );

  const [deaktiviere, { loading: deaktiviereLaeuft }] = useMutation(
    ZUGANG_DEAKTIVIEREN,
    {
      update(cache, { data }) {
        if (data?.deaktiviereZugang.__typename === ZUGANG_AKTIVIERUNG_SUCCESS) {
          schreibeAktivInCache(cache, false);
        }
      },
    },
  );

  async function setzeAktiv(neuerWert: boolean): Promise<boolean> {
    try {
      if (neuerWert) {
        const { data } = await aktiviere({ variables: { uidZugang } });
        return data?.aktiviereZugang.__typename === ZUGANG_AKTIVIERUNG_SUCCESS;
      } else {
        const { data } = await deaktiviere({ variables: { uidZugang } });
        return (
          data?.deaktiviereZugang.__typename === ZUGANG_AKTIVIERUNG_SUCCESS
        );
      }
    } catch (error) {
      Sentry.captureException(error);
      return false;
    }
  }

  return { setzeAktiv, loading: aktiviereLaeuft || deaktiviereLaeuft };
}
